// blakfy-cookie/src/i18n/translations/ar.js — Arabic translations

export default {
  title: "تفضيلات ملفات تعريف الارتباط",
  intro:
    "يستخدم هذا الموقع ملفات تعريف الارتباط لتحسين تجربتك. راجع سياسة ملفات تعريف الارتباط للحصول على التفاصيل.",
  policyLink: "سياسة ملفات تعريف الارتباط",
  acceptAll: "قبول الكل",
  rejectAll: "رفض الكل",
  preferences: "التفضيلات",
  save: "حفظ الخيارات",
  close: "إغلاق",
  cat: {
    essential: {
      title: "ملفات تعريف الارتباط الأساسية",
      desc: "ضرورية لعمل الموقع. لا يمكن تعطيلها.",
      always: "نشط دائمًا",
    },
    analytics: {
      title: "ملفات تعريف الارتباط التحليلية",
      desc: "تُستخدم لجمع إحصائيات الزيارات المجهولة.",
    },
    marketing: {
      title: "ملفات تعريف الارتباط التسويقية",
      desc: "تُستخدم للإعلان المخصص وإعادة الاستهداف.",
    },
    functional: {
      title: "ملفات تعريف الارتباط الوظيفية",
      desc: "تُستخدم لتذكر التفضيلات مثل اللغة والسمة.",
    },
  },
  placeholder: {
    title: "تم حظر المحتوى",
    desc: "تحتاج إلى السماح بملفات تعريف الارتباط لـ {category} لعرض هذا المحتوى.",
    cta: "السماح",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
